import styled from 'styled-components';
import { asRem } from 'utils';
import { breakpoints, colors } from 'components/Theme';

export default styled.div`
  position: absolute;
  background-color: ${({ backgroundColor }) => backgroundColor || colors.pink.c800};
  width: 100%;
  z-index: 2;
  color: ${colors.white.c500};
  text-align: center;
  border-top-left-radius: ${asRem(8)};
  border-top-right-radius: ${asRem(8)};
  top: 0;
  left: 0;
  right: 0;

  height: ${asRem(24)};
  line-height: ${asRem(24)};

  .mime-elements-headline-5 {
    font-size: ${asRem(14)};
    margin-bottom: 0;
  }

  @media (min-width: ${breakpoints.lg}) {
    height: ${asRem(32)};
    line-height: ${asRem(32)};

    .mime-elements-headline-5 {
      font-size: ${asRem(16)};
    }
  }

  &.small {
    .mime-elements-headline-5 {
      font-size: ${asRem(12)};
    }

    @media (min-width: ${breakpoints.lg}) {
      .mime-elements-headline-5 {
        font-size: ${asRem(14)};
      }
    }
  }
`;
